// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { first } from 'lodash/fp';

// Utils
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { getElement } from '../../../../../../../common/elements/utils/elementTraversalUtils';
import { isLocationRootBoard } from '../../../../../../../common/elements/utils/elementLocationUtils';
import { getBoardUrl } from '../../../../../../../common/permissions/urlPermissionUtils';
import { getNotificationsReferencedPermissionIds } from '../../../../../../../common/notifications/notificationsListUtils';

// Selector
import { getElements } from '../../../../../../element/selectors/elementsSelector';
import { getGroupId, getGroupNotifications, getGroupTitle } from '../../groups/notificationGroupUtils';
import { isSkeleton } from '../../../../../../../common/elements/utils/elementTypeUtils';
import getGridSize from '../../../../../../utils/grid/gridSizeSelector';

// Components
import BaseNotificationGroup from './BaseNotificationGroup';
import Icon from '../../../../../../components/icons/Icon';
import NotificationGroupToolsOptOutUtil from '../optOutPopup/NotificationGroupToolsOptOutUtil';
import ListItemBoardIcon from '../../../../../../components/popupPanel/listItems/ListItemBoardIcon';

// Styles
import './NotificationGroupElement.scss';

const ReplacementBoardIcon = () => (
    <div className="ReplacementBoardIcon">
        <Icon name="notification-unshare-board" />
    </div>
);

const mapStateToProps = createSelector(
    (state, ownProps) => ownProps.group,
    getElements,
    getGridSize,
    (group, elements, gridSize) => {
        const elementId = getGroupId(group);
        const element = getElement(elements, elementId);

        const title = getTitle(element) || getGroupTitle(group);

        return {
            element,
            elementId,
            title,
            gridSize,
        };
    },
);

const getNotificationBoardUrl = (props) => {
    const { group } = props;

    const boardId = getGroupId(group);

    const notifications = getGroupNotifications(group);
    const permissionIds = getNotificationsReferencedPermissionIds(notifications);
    const permissionId = first(permissionIds);

    return getBoardUrl({ boardId, permissionId });
};

const NotificationGroupElement = (props) => {
    const { title, element, elementId, group, gridSize } = props;

    const figure =
        element && !isSkeleton(element) ? (
            <ListItemBoardIcon element={element} gridSize={gridSize} size={4} />
        ) : (
            <ReplacementBoardIcon />
        );

    const isRoot = isLocationRootBoard(element);
    const actions = !isRoot ? <NotificationGroupToolsOptOutUtil boardId={elementId} group={group} /> : null;

    const boardUrl = getNotificationBoardUrl(props);

    return (
        <BaseNotificationGroup
            {...props}
            className="NotificationGroupElement"
            figure={figure}
            url={boardUrl}
            text={title}
            actions={actions}
        />
    );
};

NotificationGroupElement.propTypes = {
    notification: PropTypes.object,
    element: PropTypes.object,
    group: PropTypes.object,
    title: PropTypes.string,
    elementId: PropTypes.string,
    gridSize: PropTypes.number,
    onClick: PropTypes.func,
};

const enhance = connect(mapStateToProps);

export default enhance(NotificationGroupElement);
